
<p-blockUI [target]="pnl" [blocked]="blockedPanel">
  <i class="pi pi-spin pi-cog" style="font-size: 3rem"></i>
</p-blockUI>
<p-card #pnl>
Product Cart...
<div>
<p-table [value]="productCart">
    <ng-template pTemplate="header">
      <tr>
        <th>S.No</th>
        <th>Name</th>
        <th>Code</th>
        <th>Variant</th>
        <th>Quantity</th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-product let-rowIndex="rowIndex">
        <tr>
        <td>{{rowIndex+1}}</td>
        <td>{{product.name}}</td>
        <td>{{product.productCode}}</td>
        <td>{{product.selectedVariant?.name}}
          <p-dropdown [options]="product.productVariantMappings" 
          [(ngModel)]="product.selectedVariant" optionLabel="variant.name" optionValue="variant"></p-dropdown>  

        </td>
        <td>
            <p-inputNumber [min]="1" [(ngModel)]="product.quantity">
            </p-inputNumber >
        </td>
        <td>
          <p-button icon="pi pi-trash"  class="p-button-danger" (onClick)="removeFromCart(rowIndex)"></p-button>
        </td>
      </tr>
    </ng-template>

</p-table>
</div>
<div>
    <div>
        <h1
        class="text-gray-900 text-3xl mb-4 font-medium title-font text-red-500"
      >
        Product Enquiry
      </h1>
      <div class="relative mb-4">
        <label for="name" class="leading-7 text-sm text-gray-600">Company Name</label>
        <input
          pInputText
          type="text"
          id="name"
          name="name"
          [(ngModel)]="customer.name"
          class="
            w-full
            bg-white
            rounded
            border border-gray-300
            text-base
            outline-none
            text-gray-700
            py-1
            px-3
            leading-8
          "
        />
      </div>
      <div>
      <label for="name" class="leading-7 text-sm text-gray-600">Your Name</label>
        <input
          pInputText
          type="text"
          id="name"
          name="name"
          [(ngModel)]="customer.primarySalesContact.name"
          class="
            w-full
            bg-white
            rounded
            border border-gray-300
            text-base
            outline-none
            text-gray-700
            py-1
            px-3
            leading-8
          "
        />
      </div>
      <div class="relative mb-4">
        <label for="email" class="leading-7 text-sm text-gray-600">Email</label>
        <input
         pInputText
          type="email"
          id="email"
          name="email"
          class="
            w-full
            bg-white
            rounded
            border border-gray-300
            text-base
            outline-none
            text-gray-700
            py-1
            px-3
            leading-8
          "
          [(ngModel)]="customer.customerEmail"
        />
      </div>
      <div class="relative mb-4">
        <label for="message" class="leading-7 text-sm text-gray-600"
          >Phone</label
        >
        <input
         pInputText
          id="message"
          name="message"
          [(ngModel)]="customer.phone"
          class="
            w-full
            bg-white
            rounded
            border border-gray-300
            h-32
            text-base
            outline-none
            text-gray-700
            py-1
            px-3
            resize-none
            leading-6
            transition-colors
            duration-200
            ease-in-out
          "
        />
      </div>
    </div>
    <p-button icon="pi pi-send" label="Enquire Now" (onClick)="sendEnquiry()"></p-button>
</div>
</p-card>
